import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IThinkAnalyticsRepository } from '../../repositories/interfaces/IThinkAnalyticsRepository';
import { IThinkAnalyticsGetMoreLikeThisResponse } from '../../../entity/interface/iThinkAnalytics';

export interface IGetBecauseYouWatchedMultipleUseCase {
    execute(apiKey: string, token: string, queryParams: any): Promise<IThinkAnalyticsGetMoreLikeThisResponse>;
}

export class GetBecauseYouWatchedMultipleUseCase implements IGetBecauseYouWatchedMultipleUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get getBecauseYouWatchedMultipleRepository(): IThinkAnalyticsRepository {
        return container.resolve<IThinkAnalyticsRepository>(DI.REPOSITORIES.IThinkAnalyticsRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }
    async execute(apiKey: string, token: string, queryParams: any): Promise<IThinkAnalyticsGetMoreLikeThisResponse> {
        return this.getBecauseYouWatchedMultipleRepository.getBecauseYouWatchedMultiple(apiKey, token, queryParams);
    }
}
